import { createApp } from 'vue'
import { nextTick } from '@vue/runtime-core'
import { router } from '@/router/router.js'
import i18n from './plugins/i18n'
import ant from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import App from './App.vue'
import { api } from '@/util/api'
import { notice } from '@/util/notice'
import * as list from '@/util/list'
import dayjs from 'dayjs'

const isPhone = navigator.userAgent.includes('Mobile')

const app = createApp(App)

nextTick(() => {
  app.config.globalProperties.$isPhone = isPhone
})

// 註冊全域變數
app.provide('$api', api)
app.provide('$t', i18n.global.t)
app.provide('$notice', notice)
app.provide('$dayjs', dayjs)
app.provide('$list', list)

app.use(router).use(i18n).use(ant).mount('#app')
